export const breakpoints = {
  mobile: 690,
  tabletXS: 768,
  tablet: 1024,
  desktopXS: 1200,
  desktop: 1440,
}
